import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { Box, IconButton, Typography } from '@mui/material';
import { CommonTexts } from 'locale/es';
import { useNavigate } from 'react-router-dom';
import { AppColors } from 'resources/AppColors';

function AssociateMenuOption({ entityId, showText }) {
  const navigate = useNavigate()

  function handleAssociateContent() {
    navigate(`${entityId}/associate`, { state: { entityId } })
  }

  return (
    <Box onClick={handleAssociateContent} p={"6px"} sx={{ width: "100%" }} >
      <IconButton data-cy="table-associate-button">
        <GroupAddIcon sx={{ fill: AppColors.PRIMARY }} />
        {showText &&
          <Typography variant="menu_list_text" >
            {CommonTexts.ASSOCIATE}
          </Typography>
        }
      </IconButton>
    </Box>
  )
}

export default AssociateMenuOption